var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['switch', _vm.classes]},[_c('label',[_c('input',{attrs:{"type":"checkbox","name":_vm.name},domProps:{"checked":_vm.isChecked},on:{"click":function($event){return _vm.toggleSwitch(_vm.checked)}}}),_c('span')])])
}
var staticRenderFns = []

export { render, staticRenderFns }